export default [
  {
    key: 'stockBinId',
    label: 'field.bin',
    rules: 'required',
    type: 'nAsynSingleSelection',
    repository: 'stockBin',
    selectionKey: 'id',
    selectionLabel: 'code',
  },
  {
    key: 'itemId',
    label: 'field.item',
    rules: 'required',
    type: 'nAsynSingleSelection',
    repository: 'item',
    selectionKey: 'id',
    selectionLabel: 'label',
  },
  {
    key: 'quantity',
    label: 'field.quantity',
    rules: 'required|integer|min_value:1',
    type: 'currency',
  },
  {
    key: 'type',
    label: 'field.stock',
    rules: 'required',
    type: 'radio',
    options: [
      { text: 'general.in', value: 'in' },
      { text: 'general.out', value: 'out' },
    ],
  },
  {
    key: 'remark',
    label: 'field.remark',
    rules: 'required|max:300',
    type: 'textarea',
    cols: 12,
  },
]
